// Generic CustomResponse
export interface CustomResponse<T> {
  data: T;
  count: number;
  debug?: {
    query?: string;
    countQuery?: string;
  };
}
